<template>
  <div>
    <slot v-bind="{ openModal }"/>
    <modal
      :show="showModal"
      @close="closeModal"
    >
      <template #title>
        {{ title }}
      </template>

      <template #body>
        <div class="grid gap-2 grid-cols-2 md:gap-4 md:grid-cols-3">
          <l-button
            class="justify-start flex gap-2.5 sm:text-lg sm:flex-col sm:justify-center items-center text-gray-500 border rounded-lg py-2 px-3 sm:p-4 hover:bg-gray-400/10 hover:text-blue dark:hover:text-blue-200 dark:text-white"
            @click="copyLink"
          >
            <icon name="copy" class="text-xl sm:text-3xl text-gray-700" set="regular"/>
            Copy link
          </l-button>
          <a
            :href="`sms://?&body=${url}`"
            class="flex gap-2.5 sm:text-lg sm:flex-col sm:justify-center items-center text-gray-500 border rounded-lg py-2 px-3 sm:p-4 hover:bg-gray-400/10 hover:text-blue dark:hover:text-blue-200 dark:text-white"
            rel="nofollow noopener"
            target="_blank"
            @click="closeModal"
          >
            <icon name="sms" class="text-xl sm:text-3xl text-gray-700" set="regular"/>
            SMS
          </a>
          <a
            :href="`https://www.facebook.com/sharer.php?u=${url}`"
            class="flex gap-2.5 sm:text-lg sm:flex-col sm:justify-center items-center text-gray-500 border rounded-lg py-2 px-3 sm:p-4 hover:bg-gray-400/10 hover:text-blue dark:hover:text-blue-200 dark:text-white"
            rel="nofollow noopener"
            target="_blank"
            @click="closeModal"
          >
            <icon name="facebook" class="text-xl sm:text-3xl" set="brands"/>
            Facebook
          </a>
          <a
            :href="`https://twitter.com/intent/tweet?source=tweetbutton&text=&url=${url}`"
            class="flex gap-2.5 sm:text-lg sm:flex-col sm:justify-center items-center text-gray-500 border rounded-lg py-2 px-3 sm:p-4 hover:bg-gray-400/10 hover:text-blue dark:hover:text-blue-200 dark:text-white"
            rel="nofollow noopener"
            target="_blank"
            @click="closeModal"
          >
            <icon name="twitter" class="text-xl sm:text-3xl" set="brands"/>
            Twitter
          </a>
          <a
            :href="`https://web.whatsapp.com/send?text=${url}`"
            class="flex gap-2.5 sm:text-lg sm:flex-col sm:justify-center items-center text-gray-500 border rounded-lg py-2 px-3 sm:p-4 hover:bg-gray-400/10 hover:text-blue dark:hover:text-blue-200 dark:text-white"
            rel="nofollow noopener"
            target="_blank"
            @click="closeModal"
          >
            <icon name="whatsapp" class="text-xl sm:text-3xl" set="brands"/>
            WhatsApp
          </a>
          <a
            :href="`https://telegram.me/share/url?url=${url}`"
            class="flex gap-2.5 sm:text-lg sm:flex-col sm:justify-center items-center text-gray-500 border rounded-lg py-2 px-3 sm:p-4 hover:bg-gray-400/10 hover:text-blue dark:hover:text-blue-200 dark:text-white"
            rel="nofollow noopener"
            target="_blank"
            @click="closeModal"
          >
            <icon name="telegram" class="text-xl sm:text-3xl" set="brands"/>
            Telegram
          </a>
        </div>
      </template>
    </modal>
  </div>
</template>

<script setup>
import Icon from "@/components/Icon.vue"
import LButton from "@/components/buttons/LButton.vue"
import Modal from "@/components/modals/Modal.vue"
import useClipboard from "vue-clipboard3"
import { computed, ref } from "vue"
import { toast } from "@/notifications"

const props = defineProps({
  title: {
    type: String,
    default: "Share this page",
  },
  subtitle: {
    type: String,
  },
  url: {
    type: String,
  },
})

const { toClipboard } = useClipboard()

const url = computed(() => (props.url || window.location.href))

const showModal = ref(false)

const openModal = () => {
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
}

const copyLink = () => {
  toClipboard(url.value).then(() => {
    toast.success("Link copied to clipboard")
  }, () => {
    toast.error("There was a problem copying the link to the clipboard")
  }).finally(closeModal)
}
</script>
